import "../../styles/blocks/slider.scss";

import { registerBlockType } from "@wordpress/blocks";
import blockJson from "../../../includes/blocks/content-slider/block.json";

import { useBlockProps } from "@wordpress/block-editor";
import { Panel, PanelBody, PanelHeader, CustomSelectControl, TextControl, QueryControls } from "@wordpress/components";
import { useSelect } from '@wordpress/data';

import { __ } from "@wordpress/i18n";

import React, { Component } from "react";
import Parser from "html-react-parser";
import Slider from "react-slick";


export default class ContentSliderBlock extends Component {
	
	// constructor(props) {
	// 	super(props);
	// 	this.state = {
	// 		nav1: null,
	// 		nav2: null
	// 	};
	// }

    static register() {
        registerBlockType(blockJson, {
            edit: this.edit,
            save: this.save,
        });
    }

	

	static initialize(container) {
		let contents = Parser(container.innerHTML);
		ReactDOM.render(
			<ContentSliderBlock>
				{contents}
			</ContentSliderBlock>,
			container
		);
		container.classList.remove("loading");
	}

	static initializeAll() {
		const contentSliderDivs = document.getElementsByClassName("slider-container");

		for (const div of contentSliderDivs) {
			ContentSliderBlock.initialize(div);
		}
	}

	static edit(props) {
		const { attributes, setAttributes } = props;

		const blockProps = useBlockProps({
			className: "svcv-content-slider-block-container"
		});
		const controlProps = useBlockProps({
			className: "svcv-content-slider-block-controls"
		});


		const {postTypesRef, categoriesRef} = useSelect((select) => {
			const postTypes = (select('core').getPostTypes( { per_page: -1, } ) ?? [])
				.map((item) => {
					return {
						key: item.slug,
						name: item.name,
					}
				});

			const categories = (select('core').getEntityRecords('taxonomy', 'category', { per_page: -1}) ?? [])
				.map((item) => {
					return {
						key: item.id,
						name: item.name
					}
				});

			if (categories.length > 0 && categories[0].key !== 0) {
				categories.unshift(
					{
						key: 0,
						name: __('All Categories', 'svcv'),
					}
				);
			}

			return {postTypesRef: postTypes, categoriesRef: categories};
		}, []);

		const sortingOrders = [
			{
				key: 'DESC',
				name: 'Du plus récent au plus ancien'
			},
			{
				value: 'ASC',
				name: 'Du plus ancien au plus récent'
			},
		];
	
		return (
			<div {...blockProps}>
				<Panel>
					<PanelHeader> Slider de Contenu </PanelHeader>
					<PanelBody {...controlProps}>
						<TextControl
							label={__( 'Number of elements', 'svcv')}
							value={attributes.numberOfElements == -1 ? __('All', 'svcv') : attributes.numberOfElements}
							onChange={(selected) => {
								let newValue = parseInt(selected);
								if (isNaN(newValue)) newValue = -1;

								setAttributes({numberOfElements: newValue})
							}}
						/>
						<CustomSelectControl
							label={__( 'Content type', 'svcv')}
							options={ postTypesRef }
							value={ postTypesRef.find( (item) => item.key === attributes.postType ) }
							onChange={ (event) => setAttributes({ postType: event.selectedItem.key }) }
						/>
						<CustomSelectControl
							label={__( 'Category', 'svcv')}
							options={ categoriesRef }
							value={ categoriesRef.find( (item) => parseInt(item.key) === attributes.categoryId ) }
							onChange={ (event) => setAttributes({ categoryId: parseInt(event.selectedItem.key) }) }
						/>
						<CustomSelectControl
							label={__( 'Sorting order', 'svcv')}
							options={ sortingOrders }
							value={ sortingOrders.find( (item) => item.key === attributes.sortingOrder ) }
							onChange={ (event) => setAttributes({ sortingOrder: event.selectedItem.key }) }
						/>
					</PanelBody>
				</Panel>
			</div>
		);
		
	}

    static save() {
        return null;
    }



	// componentDidMount() {
	// 	this.setState({
	// 		nav1: this.slider1,
	// 		nav2: this.slider2
	// 	});
	// }

	render() {
		const contents = this.props.children;

		return (
		<>
		<Slider
			// asNavFor={this.state.nav2}
			ref={slider => (this.slider1 = slider)}
			autoplay={true}
			autoplaySpeed={8000}
			dots={true}
			accessibility={true}
			mobileFirst={true}
			pauseOnHover={true}
			pauseOnFocus={true}
			pauseOnDotsHover={true}

			className="slider-main"
		>
			{contents}
		</Slider>
		</>
		);
	}
}